import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { CheckCircle, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';

export default function ThankYouPage() {
  return (
    <>
      <Helmet>
        <title>Tesekkurler | Talebiniz Alindi</title>
      </Helmet>

      <section className="min-h-[60vh] flex items-center justify-center py-16">
        <div className="max-w-lg mx-auto px-4 text-center">
          <CheckCircle className="h-16 w-16 text-emerald-500 mx-auto mb-6" />
          <h1 className="text-3xl font-semibold mb-4" data-testid="thankyou-title">Talebiniz Alindi</h1>
          <p className="text-muted-foreground mb-8 leading-relaxed">
            Teklif talebiniz basariyla iletildi. Ekibimiz en kisa surede inceleyip sizinle iletisime gececektir.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button variant="outline" data-testid="thankyou-home">
                Ana Sayfa
              </Button>
            </Link>
            <Link to="/hizmetler">
              <Button data-testid="thankyou-services">
                Hizmetleri Incele <ArrowRight className="ml-2 h-4 w-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
